"use client";

import { c as _c } from "react/compiler-runtime";
import { ButtonGroup } from "../ui/button-group";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "../ui/select";
import { useEffect, useState } from "react";
type MonthYearSelectorProps = {
  value: string;
  onChange: (value: string) => void;
};
export const MonthYearSelector = t0 => {
  const $ = _c(34);
  const {
    value,
    onChange
  } = t0;
  let currentMonth;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const currentDate = new Date();
    currentMonth = currentDate.getMonth() + 1;
    t1 = currentDate.getFullYear();
    $[0] = currentMonth;
    $[1] = t1;
  } else {
    currentMonth = $[0];
    t1 = $[1];
  }
  const currentYear = t1;
  const [month, setMonth] = useState(currentMonth);
  const [year, setYear] = useState(currentYear);
  let t2;
  let t3;
  if ($[2] !== value) {
    t2 = () => {
      if (value) {
        const [yearPart, monthPart] = value.split("-");
        const parsedYear = parseInt(yearPart, 10);
        const parsedMonth = parseInt(monthPart, 10);
        if (!isNaN(parsedYear) && !isNaN(parsedMonth)) {
          queueMicrotask(() => setMonth(parsedMonth));
          queueMicrotask(() => setYear(parsedYear));
        }
      } else {
        queueMicrotask(() => setMonth(currentMonth));
        queueMicrotask(() => setYear(currentYear));
      }
    };
    t3 = [value, currentMonth, currentYear];
    $[2] = value;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const months = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = Array.from({
      length: 2
    }, (_, i) => currentYear + i);
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const years = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = months.map(_temp);
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const monthItems = t6;
  let t7;
  if ($[8] !== onChange) {
    t7 = (selectedYear, selectedMonth) => {
      const formatted = `${selectedYear}-${String(selectedMonth).padStart(2, "0")}`;
      onChange(formatted);
    };
    $[8] = onChange;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const emitChange = t7;
  let t8;
  if ($[10] !== emitChange || $[11] !== year) {
    t8 = val => {
      setMonth(val);
      emitChange(year, val);
    };
    $[10] = emitChange;
    $[11] = year;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const handleMonthChange = t8;
  let t9;
  if ($[13] !== emitChange || $[14] !== month) {
    t9 = val_0 => {
      setYear(val_0);
      emitChange(val_0, month);
    };
    $[13] = emitChange;
    $[14] = month;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const handleYearChange = t9;
  let t10;
  if ($[16] !== handleMonthChange) {
    t10 = value_0 => handleMonthChange(value_0 as number);
    $[16] = handleMonthChange;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SelectTrigger className="w-full max-w-48" aria-label="Month"><SelectValue /></SelectTrigger>;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SelectContent alignItemWithTrigger={false} align="start"><SelectGroup><SelectLabel>Month</SelectLabel>{monthItems.map(_temp2)}</SelectGroup></SelectContent>;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== month || $[21] !== t10) {
    t13 = <Select items={monthItems} value={month} onValueChange={t10} modal={false}>{t11}{t12}</Select>;
    $[20] = month;
    $[21] = t10;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = years.map(_temp3);
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== handleYearChange) {
    t15 = value_1 => handleYearChange(value_1 as number);
    $[24] = handleYearChange;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SelectTrigger className="w-full max-w-48" aria-label="Year"><SelectValue /></SelectTrigger>;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SelectContent alignItemWithTrigger={false} align="end"><SelectGroup><SelectLabel>Year</SelectLabel>{years.map(_temp4)}</SelectGroup></SelectContent>;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== t15 || $[29] !== year) {
    t18 = <Select items={t14} value={year} onValueChange={t15} modal={false}>{t16}{t17}</Select>;
    $[28] = t15;
    $[29] = year;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== t13 || $[32] !== t18) {
    t19 = <ButtonGroup>{t13}{t18}</ButtonGroup>;
    $[31] = t13;
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  return t19;
};
function _temp(label, index) {
  return {
    label,
    value: index + 1
  };
}
function _temp2(item) {
  return <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>;
}
function _temp3(item_0) {
  return {
    label: item_0,
    value: item_0
  };
}
function _temp4(item_1) {
  return <SelectItem key={item_1} value={item_1}>{item_1}</SelectItem>;
}